var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-wraper"},[_c('div',{staticClass:"viewer-container",attrs:{"id":"pdf-ui"}}),_c('uploader',{ref:"uploader",attrs:{"options":_vm.options,"autoStart":false},on:{"file-added":_vm.onFileAdded,"file-success":_vm.onFileSuccess,"file-error":_vm.onFileError}},[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }